import { IParamsGetPatientSearch } from 'app/api/treatment/model'

export const TreatmentKeys = {
  allPatientSearches: ['PatientSearch'] as const,
  listPatientSearches: () =>
    [...TreatmentKeys.allPatientSearches, 'PatientSearches'] as const,
  listPatientSearch: (filter?: IParamsGetPatientSearch) =>
    [...TreatmentKeys.listPatientSearches(), { filter }] as const,
}
